<template>
  <div class="product-page container mx-auto">
    <div
      class="row flex-nowrap justify-content-around mx-auto text-black border-bottom border-danger text-center m-5"
    >
      <h1 class="col-12 text-uppercase mt-2" id="header">gegevens</h1>
    </div>
  </div>

  <div>
    <label id="want-quo" for="bestellingType">Ik wil een offerte voor</label>
    <div class="border-select" id="bestellingType_div">
      <select
        id="bestellingType"
        class="form-select bg-light"
        name="bestellingType"
        v-model="bestellingType"
      >
        <option id="event" value="Event">een event</option>
        <option id="confe-sem" value="Congres / Seminar">
          een congres / seminar
        </option>
        <option id="fair" value="(Vak)beurs">een (vak)beurs</option>
        <option id="in-stand" value="Individuele stand">
          een individuele stand
        </option>
        <option id="project" value="Project markt">een project</option>
      </select>
    </div>
  </div>
  <div>
    <div>
      <ApplicationForm :event="bestellingType" />
    </div>
  </div>
</template>

<script>
import ApplicationForm from "../components/ApplicationForm.vue";

export default {
  name: "Application",
  components: {
    ApplicationForm,
  },
  data() {
    return {
      bestellingType: "Project markt",
    };
  },
  created() {
    this.$store.commit("storeLocUpdate", true);
  },
  methods: {},
  computed: {},
};
</script>

<style lang=css>
 @import "../styles/application.css";
</style>